module.exports = __webpack_public_path__ + "img/mid.9990018e.png";